import { AbstractControl } from '@angular/forms';

export abstract class AbstractEditionModalForm<T> {
  abstract form: AbstractControl;

  abstract updateForm(model?: T, params?: any);

  abstract getFormData(): any;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/edition-modal/abstract-edition-modal-form.ts